module.exports = __webpack_public_path__ + "static/img/nf.0be1cf96.svg";